import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=4f659cb6&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=4f659cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f659cb6",
  null
  
)

export default component.exports